import { ModuleWithProviders, NgModule, Input, Provider } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Component } from '@angular/core';
import { JurRoutingModule, routedComponents } from './jur-routing.module';
import { RestService } from '../@core/utils/rest.service';
import { NcalayerService } from '../@core/utils/ncalayer/ncalayer.service';
import { MainComponent } from './main/main.component';
import { PaymentComponent } from './payment/payment.component';
import { ReestrComponent } from './reestr/reestr.component';

import { NbDatepickerModule, NbInputModule, NbSelectModule, NbStepperModule, NbCardModule, NbTabsetModule, NbActionsModule, NbAlertModule,NbMenuModule } from '@nebular/theme';
import { ReactiveFormsModule} from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { ClickOutsideModule } from 'ng-click-outside';
import { HeadBtnComponent } from './head-btn/head-btn.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { PaystoriesComponent } from './paystories/paystories.component';
import { EmployeeComponent } from './employee/employee.component';
import { CabinetComponent } from './cabinet/cabinet.component';
import { AppealComponent } from './appeal/appeal.component';
import { CallbackComponent } from './callback/callback.component';
import { NbMomentDateModule } from '@nebular/moment';
import { ThemeModule } from '../@theme/theme.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule, MatFormFieldControl } from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';

import { Ng2SmartTableModule } from 'ng2-smart-table';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { TextInputAutocompleteModule } from 'ngx-input-autocomplete';
import { polyfill as keyboardEventKeyPolyfill } from 'keyboardevent-key-polyfill';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatInputModule} from '@angular/material';


import { CustomEditorComponent1 } from './payment/custom-editor.component.1';
import { CustomEditorComponent2 } from './payment/custom-editor.component.2';
import { CustomEditorComponent3 } from './payment/custom-editor.component.3';
import { CustomEditorComponent4 } from './payment/custom-editor.component.4';
import { CustomEditorComponent5 } from './payment/custom-editor.component.5';
import { CustomEditorComponent6 } from './payment/custom-editor.component.6';
import { CustomEditorComponent7 } from './payment/custom-editor.component.7';
import { CustomEditorComponent8 } from './payment/custom-editor.component.8';
import { CustomEditorComponent9 } from './payment/custom-editor.component.9';
import { CustomEditorComponent10 } from './payment/custom-editor.component.10';
import { CustomEditorComponent11 } from './payment/custom-editor.component.11';
import { CustomEditorComponent12 } from './payment/custom-editor.component.12';

import {LayoutModule} from '@angular/cdk/layout';
import { JurComponent } from './jur.component';
import { NotFoundComponent } from './not-found/not-found.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {OverlayModule, OverlayContainer, FullscreenOverlayContainer} from '@angular/cdk/overlay';
import { NgxSoapModule } from 'ngx-soap';
import {MatTableModule} from '@angular/material/table';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import { NgSelectModule } from '@ng-select/ng-select';
import { Ng2CompleterModule } from "ng2-completer";
import { HttpClient } from '@angular/common/http';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader'
import {MatSortModule} from '@angular/material/sort';
import { CustomEditorComponent13 } from './payment/custom-editor.component.13';
import { CustomEditorComponent14 } from './payment/custom-editor.component.14';
import { CustomEditorComponent15 } from './payment/custom-editor.component.15';
import { CustomEditorComponent16 } from './payment/custom-editor.component.16';
import {MatTreeModule} from '@angular/material/tree';
import {MatSelectModule} from '@angular/material/select';


export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}
// import { SharedModule } from '../../shared/shared.module';
keyboardEventKeyPolyfill();
const JUR_COMPONENT = [
  JurComponent,
];
@NgModule({
  entryComponents: [
   // CustomEditorComponent1,

    CustomEditorComponent2,CustomEditorComponent3,
     CustomEditorComponent4 ,CustomEditorComponent5,CustomEditorComponent6,
     CustomEditorComponent7,CustomEditorComponent8,CustomEditorComponent9,
     CustomEditorComponent10, CustomEditorComponent11,CustomEditorComponent1,
     CustomEditorComponent12 ,CustomEditorComponent13,CustomEditorComponent14,
     CustomEditorComponent15 ,CustomEditorComponent16 ],
  declarations: [...routedComponents,
    MainComponent, PaymentComponent, ReestrComponent,
     HeadBtnComponent,  PaystoriesComponent,
    EmployeeComponent,
    CabinetComponent,
    AppealComponent,CallbackComponent,JUR_COMPONENT,NotFoundComponent,
    CustomEditorComponent2,CustomEditorComponent3,CustomEditorComponent5 ,
    CustomEditorComponent4,CustomEditorComponent6,CustomEditorComponent7,
    CustomEditorComponent8,CustomEditorComponent9,CustomEditorComponent10,
    CustomEditorComponent11,CustomEditorComponent1,CustomEditorComponent12,
    CustomEditorComponent13,CustomEditorComponent14,CustomEditorComponent15,CustomEditorComponent16

  ],

  imports: [
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
  }),

    Ng2CompleterModule,
    AutocompleteLibModule,
    MatTreeModule,
    OverlayModule,
    MatTableModule,
    LayoutModule,
    MatTooltipModule,
    CommonModule,
    JurRoutingModule,
    NbDatepickerModule,
    NbInputModule,
    TextInputAutocompleteModule,
    NbSelectModule,
    ClickOutsideModule,
    NbStepperModule,
    NbCardModule,
    NbTabsetModule,
    FormsModule,
    NgxEchartsModule,
    NgxChartsModule,
    NbActionsModule,
    NbAlertModule,
    NbMomentDateModule,
    MatCheckboxModule,
    MatSortModule,
    MatStepperModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatNativeDateModule,
    Ng2SmartTableModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatInputModule,
    NbMenuModule,
    FormsModule,
    ReactiveFormsModule,
    // SharedModule
    ThemeModule.forRoot(),
    NgxSoapModule
  ],

  providers: [RestService, NcalayerService,
    {provide: MAT_DATE_LOCALE, useValue: 'ru-RU'},
    {provide: OverlayContainer, useClass: FullscreenOverlayContainer}
  ],


})



export class JurModule { }
